module.exports = __webpack_public_path__ + "Flama-SemiboldItalic.ttf?3a7bce9d0c9d298893b1339cc64b992d";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-SemiboldItalic.ttf
// module id = 904
// module chunks = 0